import type Vue from 'vue';
import { resolveInjected } from '~/utils/nuxt-instance';

/** Branding config injected by plugins/whitelabel.js. */
export function useWhitelabel(): Vue['$whitelabel'] {
  return resolveInjected('$whitelabel');
}

/**
 * Organizer branding fetched by plugins/axios.ts. Only present when a
 * whitelabel organizer is configured, and injected asynchronously.
 */
export function useWhitelabelLite(): Vue['$whitelabelLite'] | undefined {
  return resolveInjected('$whitelabelLite');
}
